import { MaterialReactTable, useMaterialReactTable } from "material-react-table"
import SortIcon from "@mui/icons-material/Sort"
import { TableCellProps } from "@mui/material"

export type User = {
  metricName: string
  mtdBudget: number
  mtdActual: number
  variance: number
}
export const CommonTable = ({
  isloading,
  data,
  column,
  enableGrouping,
}: {
  isloading?: boolean
  data: any[]
  column: any[]
  enableGrouping?: any
}) => {
  const headCellProps: TableCellProps = {
    align: "center",
    sx: {
      backgroundColor: "#1A428A",
      color: "#fff",
      fontWeight: "bold",
      border: "0.5px solid #E4E4E4",
      boxShadow: " #00000022 1.95px  0px 2.6px",
      paddingY: "12px",
      paddingX: 3,
    },
  }

  const defaultTableProps = {
    enableColumnActions: false,
    enableColumnFilters: false,
    enablePagination: false,
    enableSorting: false,
    enableBottomToolbar: false,
    enablePinning: true,
    enableTopToolbar: false,
    // enableGrouping: true,

    muiTablePaperProps: {
      elevation: 0,
    },
    muiTableHeadCellProps: headCellProps,
    muiTableContainerProps: {
      sx: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        position: "absolute",
        borderRadius: "5px",
      },
    },
    muiTableBodyCellProps: {
      sx: {
        height: "60px",
        border: "0.5px solid #E4E4E4",
        boxShadow: "#00000022 1.95px 0px 2.6px",
        color: "black",
      },
    },
    muiTableBodyRowProps: {
      hover: false,
    },
    enableStickyHeader: true,
    enableStickyFooter: true,
  }

  const table = useMaterialReactTable({
    ...defaultTableProps,
    columns: column,
    data: data,
    enableSorting: true,
    enableMultiSort: false,
    muiTableHeadCellProps: {
      align: "center",
      sx: {
        backgroundColor: "#1A428A",
        color: "#fff",
        fontWeight: "bold",
        height: "32px",
        boxShadow: " #00000022 1.95px  0px 2.6px",
        border: "1px solid #E4E4E4",
        // padding: "0 !important",
        // border: "1px solid red"
      },
    },
    muiTableHeadRowProps: {},
    muiTableContainerProps: {
      sx: {
        borderRadius: "none",
        height: "fit-content",
        maxWidth: "93vw",
        maxHeight: "70vh",
      },
    },
    icons: {
      ArrowDownwardIcon: () => (
        <SortIcon sx={{ color: "#fff", ml: "7px", marginLeft: "10px" }} />
      ),
    },
    muiTableBodyCellProps: ({ cell, table }) => {
      return {
        align: "center",
        onClick: () => table.setEditingCell(cell),
        sx: {
          height: "48px",
          boxShadow: "#00000022 1.95px 0px 2.6px",
          color: "black",
          border: "1px solid #E4E4E4",
        },
      }
    },
    state: {
      isLoading: isloading || false,
      columnVisibility: { Actions: false },
      columnPinning: {
        left: ["mrt-row-actions", "office", "provider"],
      },
    },
  })

  return <MaterialReactTable table={table} enableGrouping={enableGrouping} />
}

export default CommonTable
